import React from 'react'
import Header from '../../../components/Dashboard/Header'
import Ideabar from '../../../components/Dashboard/Innovator/Ideabar'

function EditIdea() {
  return (
    <div className='bg-[#F3F4FF] h-full'>
      <Header/>
      <Ideabar/>
    </div>
  )
}

export default EditIdea